import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_PETITION_SIGNER_REENGAGEMENT_RECOMMENDATIONS_ENABLED = defineFcm(
	'comms_stack_petition_signer_reengagement_recommendations_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
